<div class="background">
  <app-website-header></app-website-header>
  <app-carousel></app-carousel>
  <div class="home">
    <img src="../../assets/images/icons/home-icon.svg" alt="" [routerLink]="['/']">
    <div [routerLink]="['/']">Home</div>
    <div >/ Healthcare Services</div>
  </div>

  <div class="heading-with-line">
    <div class="line1"></div>
    <div class="heading-text" style="font-weight: 600;font-size:18; font-family: 'Georgia' !important;">Health Care</div>
    <div class="line2"></div>
  </div>
  <div class="card-container">
    <div class="card" (click)="navigateTo('Doctors')">
      <img src="../../../../assets/images/doctors-healthcare.jpg" alt="doctors-img">
      <p>Doctors</p>
    </div>
    <div class="card" (click)="navigateTo('Hospitals')">
      <img src="../../../../assets/images/hospitals-healthcare.jpg" alt="hospitals-img">
      <p>Hospitals</p>
    </div>
    <div class="card" (click)="navigateTo('Labs')">
      <img src="../../../../assets/images/labs-healthcare.jpg" alt="labs-img">
      <p>Labs</p>
    </div>
    <div class="card" (click)="navigateTo('Clinics')">
      <img src="../../../../assets/images/clinics-healthcare.jpg" alt="clinics-img">
      <p>Clinics</p>
    </div>
  </div>
  <app-website-footer></app-website-footer>
</div>
